import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_setting_card = _resolveComponent("setting-card")!

  return (_ctx.config)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_setting_card, _mergeProps(_ctx.binds, {
          active: _ctx.config.activateTask,
          "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.activateTask) = $event)),
          hideMoreVert: true,
          hidePrevious: true,
          onUpdateProfile: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateProfile()))
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-center",
              style: {"min-width":"600px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "8" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      style: {"border-radius":"16px !important"},
                      class: "oss-list-item",
                      title: "Gestionnaire des tâches"
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateProfile())),
                          modelValue: _ctx.config.activateTask,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.activateTask) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["active"])
      ]))
    : _createCommentVNode("", true)
}